import Vue from 'vue'

Vue.filter('price', function(value) {
	return (parseFloat(value || '0') / 100).toFixed(2)
})
Vue.filter('dateFormat', function(value, fmt) {
	let date = Date.parseDate(value)
	if (!date) return ''
	return date.format(fmt)
})